import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  formatPrice,
  viewPdp,
  isImageUrl,
  getPersonaPriceListDetail,
} from "@/components/VisualSearch/v1/utils"
import { ProductCard } from "@kohler-dsm-library/kohler-core"
import missingIllustration from "@/public/images/image-missing.png"

const ProductCards = props => {
  const { skuLists, setProductId, setShow, prodResult } = props
  const [productImages, setProductImages] = useState({})

  useEffect(() => {
    if (prodResult) {
      const fetchImages = async () => {
        const images = {}
        let imageData
        for (const productDetails of prodResult) {
          if (
            productDetails?.isoImageURL &&
            productDetails.isoImageURL !== ""
          ) {
            imageData = (await isImageUrl(productDetails?.isoImageURL))
              ? productDetails.isoImageURL
              : missingIllustration.src
          }
          images[productDetails.sku] = { src: imageData, alt: "Product Image" }
        }
        setProductImages(images)
      }
      fetchImages()
    }
  }, [prodResult])

  const productProps = {
    type: "Product Card",
    maxWidth: "460px",
  }

  const getProductDetails = skuVal => {
    const productDetails = prodResult?.find(item => item.sku === skuVal)
    if (productDetails) {
      const prices = getPersonaPriceListDetail(productDetails)
      const imageData = productImages[skuVal] || {
        src: missingIllustration?.src,
        alt: "Image Not Available",
      }

      return {
        ...productProps,
        productNumber: productDetails?.productNo,
        pdpUrl: productDetails?.pdpUrl,
        image: imageData,
        title: {
          text: productDetails?.name,
        },
        description: {
          text:
            productDetails?.longDescription ||
            productDetails?.shortDescription ||
            "",
        },
        price: {
          text: formatPrice(prices),
        },
        productDetails: {
          ...productProps.productDetails,
          SKU: {
            text: productDetails?.sku,
          },
        },
      }
    }
    return productProps
  }

  return (
    <div className="result-container flex-wrap card-gap result-items1">
      {skuLists.map((val, index) => {
        const getProductDetailsObj = getProductDetails(val)
        return (
          <React.Fragment key={index}>
            <div className="other-match-container fixed-card-height d-flex flex-column align-items-stretch w-100">
              <div className="d-flex flex-column h-100 justify-content-between align-items-center w-100">
                <ProductCard
                  {...getProductDetailsObj}
                  onClick={() => {
                    viewPdp(getProductDetailsObj?.pdpUrl)
                  }}
                />
                <div className="service-part-container">
                  <span
                    className="service-part-text"
                    onClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                      setShow(true)
                      setProductId(getProductDetailsObj?.productNumber)
                    }}
                  >
                    Service Parts
                  </span>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
ProductCards.propTypes = {
  skuLists: PropTypes.array.isRequired,
  setProductDtlId: PropTypes.func.isRequired,
  setProductId: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
  prodResult: PropTypes.array.isRequired,
  setPartsFlag: PropTypes.func.isRequired,
}

export default ProductCards
